export const ORIENTATION_LEFT_TO_RIGHT = 'leftToRight';
export const ORIENTATION_TOP_TO_BOTTOM = 'topToBottom';
export const ORIENTATION_RIGHT_TO_LEFT = 'rightToLeft';
export const ORIENTATION_BOTTOM_TO_TOP = 'bottomToTop';
